/*
 * @Descripttion: 全局默认的基础路由
 * @Author: hehua
 * @Date: 2024-05-30 14:38:51
 * @LastEditors: hehua
 * @LastEditTime: 2024-07-19 10:52:29
 */
import Layout from '@/layout/index.vue'

const baseRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('@/views/login/forget.vue')
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/login/agreement.vue'),
    meta: { title: '个人信息保护声明' }
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import('@/views/login/disclaimer.vue'),
    meta: { title: '免责协议' }
  },
  {
    path: '/loadingLogin',
    name: 'LoadingLogin',
    component: () => import('@/views/loadingLogin.vue'),
    meta: { title: '免责协议' }
  },
  // 此处以下为系统内置应用
  {
    path: '/cleverWorkOrder',
    key: 'cleverWorkOrderLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'CleverWorkOrder',
        component: () => import('@/views/applications/cleverWorkOrder.vue')
      }
    ]
  },
  {
    path: '/sparePartsManager',
    key: 'sparePartsManagerLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'SparePartsManager',
        component: () => import('@/views/applications/sparePartsManager.vue')
      }
    ]
  },
  // 2.9 备件服务
  {
    path: '/sparePartService',
    key: 'sparePartService',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'SparePartsManager',
        component: () => import('@/views/applications/sparePartService.vue')
      }
    ]
  },
  {
    path: '/performanceManagement',
    key: 'performanceManagementLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'PerformanceManagement',
        component: () => import('@/views/applications/performanceManagement.vue')
      }
    ]
  },
  {
    path: '/maintenanceServices',
    key: 'maintenanceServicesLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'MaintenanceServices',
        component: () => import('@/views/applications/maintenanceServices.vue')
      }
    ]
  },
  {
    path: '/filingManage',
    key: 'filingManageLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'FilingManage',
        component: () => import('@/views/applications/filingManage.vue')
      }
    ]
  },
  // 绩效考核
  {
    path: '/accessGrade',
    key: 'accessGradeLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'AccessGrade',
        component: () => import('@/views/applications/accessGrade.vue')
      }
    ]
  },
  // 巡检工单 - 2024-0611新增
  {
    path: '/inspectionOrder',
    key: 'inspectionOrderLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'InspectionOrder',
        component: () => import('@/views/applications/inspectionOrder.vue')
      }
    ]
  },
  // 事项工单
  {
    path: '/eventOrderManage',
    key: 'eventOrderManage',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'EventOrder',
        component: () => import('@/views/applications/eventOrder.vue')
      }
    ]
  },
  // 工程交付 - 2024-0704新增
  {
    path: '/engineeringDelivery',
    key: 'engineeringDeliveryLayout',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'EngineeringDelivery',
        component: () => import('@/views/applications/engineeringDelivery.vue')
      }
    ]
  },
  // 数据统计 2024-07-30新增
  {
    path: '/dataCockpit',
    key: 'DataCockpit',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'DataCockpit',
        component: () => import('@/views/applications/dataCockpit.vue')
      }
    ]
  },
  // 资产管理
  {
    path: '/assetManagement',
    key: 'assetManagement',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'assetManagement',
        component: () => import('@/views/applications/assetManagement.vue')
      }
    ]
  },
  {
    path: '/assetAnalysis',
    key: 'assetAnalysis',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'assetAnalysis',
        component: () => import('@/views/applications/assetAnalysis.vue')
      }
    ]
  },
  {
    path: '/diagnosisPlan',
    key: 'diagnosisPlan',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'diagnosisPlan',
        component: () => import('@/views/applications/diagnosisPlan.vue')
      }
    ]
  },
  // 结算中心
  {
    path: '/SettlementCenter',
    key: 'SettlementCenter',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'SettlementCenter',
        component: () => import('@/views/applications/SettlementCenter.vue')
      }
    ]
  },
  // 收款中心
  {
    path: '/CollectionCenter',
    key: 'CollectionCenter',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'CollectionCenter',
        component: () => import('@/views/applications/CollectionCenter.vue')
      }
    ]
  },

  // 收款中心
  {
    path: '/CostCenter',
    key: 'CostCenter',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'CostCenter',
        component: () => import('@/views/applications/CostCenter.vue')
      }
    ]
  },
  // 巡检服务-2.8.6
  {
    path: '/inspectionServices',
    key: 'inspectionServices',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'inspectionServices',
        component: () => import('@/views/applications/inspectionServices.vue')
      }
    ]
  },
  // 工程服务-2.8.7
  {
    path: '/engineeringServices',
    key: 'engineeringServices',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'engineeringServices',
        component: () => import('@/views/applications/engineeringServices.vue')
      }
    ]
  },
  // 众包管理
  {
    path: '/outManage',
    key: 'outManage',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'outManage',
        component: () => import('@/views/applications/outManage.vue')
      }
    ]
  },
  // 众包管理
  {
    path: '/businessCenter',
    key: 'businessCenter',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'businessCenter',
        component: () => import('@/views/applications/applicationFrame.vue')
      }
    ]
  },
  // 值守服务
  {
    path: '/dutyService',
    key: 'dutyService',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        key: 'dutyService',
        component: () => import('@/views/applications/applicationFrame.vue')
      }
    ]
  },

  { path: '/404', component: () => import('@/views/404'), meta: { hidden: true, roles: ['ADMIN', 'OPERATION', 'PLATFORM'] } }
  // { path: '*', redirect: '/404', meta: { hidden: true, roles: ['ADMIN', 'OPERATION', 'PLATFORM'] } },
]

export default baseRoutes
